import React, { useState, useEffect } from 'react';
import { SelectForLast10ByAgentCode } from 'Components/Api/SDKAPI';
import { SDKLOGOUT } from 'ConstComponents';
import ReactTable from 'Components/ReactTable/ReactTable';

export const Report = () => {
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [transactions, setTransactions] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);

    const Select = async () => {
        createColumns();
        setTransactions([]);
        setLoadingOpen(true);
        var response = await SelectForLast10ByAgentCode();
        setLoadingOpen(false);
        if (!response.isAuthorized) SDKLOGOUT();
        if (!response.status) return;
        var data = JSON.parse(response.data);
        setTransactions(data);
    };

    useEffect(() => {
        Select();
    }, []);

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'ID',
            srno: true
        });

        columns.push({
            label: 'Date',
            name: 'DOC'
        });

        columns.push({
            label: 'Operator',
            name: 'OperatorName'
        });

        columns.push({
            label: 'Number',
            name: 'ConsumerNumber'
        });
        columns.push({
            label: 'Status',
            name: 'Status',
            customStatus: true
        });
        columns.push({
            label: 'Amt',
            name: 'Amount',
            textwrapwidth: 60,
            numeric: true
        });
        columns.push({
            label: 'OP ID',
            name: 'ReferenceNo'
        });

        setMainColumns(columns);
    };

    return (
        <>
            <ReactTable
                data={transactions}
                columns={mainColumns}
                headerToolbar={false}
                footerToolbar={false}
            />
        </>
    );
};
